import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {Chain} from '~/app/core/reports/models/chain';
import {Group} from '~/app/core/reports/models/group';
import {orderBy, SortDescriptor} from '@progress/kendo-data-query';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ReportService} from '~/app/core/reports/services/report.service';
import {UserService} from '~/app/core/services/user.service';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-chain-select',
  templateUrl: './chain-select.component.html',
  styleUrls: ['./chain-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChainSelectComponent),
      multi: true
    }
  ]
})
export class ChainSelectComponent implements OnInit, ControlValueAccessor {

  @Input()
  groups: Group[];
  selectedChains = [];
  selectedGroups = [];
  @Input()
  selectedChainsGrid = [];
  selectedChainsSelectedItems = [];
  public _childChainList =  [];
  hotid: string = '';

  private _chains: Chain[];
  private masterList: Chain[];
  get value(): any[] {
    return this._value;
  }

  set value(val: any[]) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }
  public multiple = false;
  // tslint:disable-next-line:no-input-rename
  @Input('value')
  private _value: any[] = [];
  onChange: any = () => {};
  onTouched: any = () => {};
  private username: string;
  get chains(): Chain[] {
    return this._chains;
  }
  @Input()
  set chains(value: Chain[]) {
    this._chains = value;
    this.childChainList = [...value];
  }
  get childChainList(): Chain[] {
    return this._childChainList;
  }

  set childChainList(value: Chain[]) {
    this._childChainList = value;
  }


  async ngOnInit() {
    this.loadingService.show();
    this.hotid = this.userService.selectedHomeOffice.hoId;
    this.username = this.userService.getUserName().toUpperCase();
     this.groups = await this.reportService.getGroupHeaders(this.hotid);
      this.masterList = await this.reportService.getCompleteStoreList(this.hotid);
      this.chains = [...this.masterList];
    this.loadingService.hide();
  }
  constructor(private  reportService: ReportService, public userService: UserService, public loadingService:LoadingIndicatorHelper ) {
  }

  addGroup() {
    this.getAllChainsFromGroup();
  }

  addAllGroups() {
    this.groups.forEach((group) => {
      this.moveStoresinGroup(group.groupId).then(r => r);
    });
    this.updateView();
  }

  addStore() {
    for (let i = this.selectedChains.length - 1; i >= 0; i--) {
      const item =  this.selectedChains[i];
      if (!this.checkDuplicate(item, this.selectedChainsGrid)) {
        console.log("add "+ item)
        const selectedObj = this.childChainList.find(stor  =>  stor.storeID === item);
        this.selectedChainsGrid.push(selectedObj);
        const selectedIndex = this.childChainList.findIndex(stor  =>  stor.storeID === item);
        this.childChainList.splice(selectedIndex, 1);
      }
    }
    this.selectedChains = [];
   this.updateView();

  }

  addAllStores() {
    for (let i = this.childChainList.length - 1; i >= 0; i--) {
      const item =  this.childChainList[i];
      if (!this.checkDuplicate(item, this.selectedChainsGrid)) {
        this.selectedChainsGrid.push(item);
        this.childChainList.splice(i, 1);
      }
    }
   this.updateView();
  }
  updateView() {
    this.selectedChainsSelectedItems = [];
    this.setValue().then(r => r);
    this.sortArray();
    this.selectedChains = [];
  }

  sortList(list, property: SortDescriptor[]) {
    return  orderBy(list, property);
  }
  async setValue() {

    const to = await this.selectedChainsGrid.map((item) => {
      return `${item.chainID}  ${item.storeID}`;
    });
    this.value = to;
  }

  removeStore() {
    this.selectedChainsSelectedItems.forEach((item) => {
      const dstore = this.selectedChainsGrid.find((items) => items.storeID === item);
      console.log("test delete ",this.selectedChainsGrid, dstore);
      this.childChainList.push(dstore);
      this.selectedChainsGrid.splice(this.selectedChainsGrid.indexOf(dstore), 1);
    });
    this.updateView();
  }

  checkDuplicate(item, dataSource) {
    return dataSource.some((ent) => ent.storeID === item.storeID);
  }

  removeAllStores() {
        for (let i = this.selectedChainsGrid.length - 1; i >= 0; i--) {
      const item = this.selectedChainsGrid[i];
      if (!this.checkDuplicate(item, this.childChainList)) {
        this.childChainList.push(item);
      }
      this.selectedChainsGrid.splice(i, 1);
    }
    this.updateView();
  }

  async moveStoresinGroup(groupId: string) {
    if(groupId == null || groupId == undefined || groupId == '') return;
    this.loadingService.show();
    this.reportService.getAssignedStores(this.hotid, groupId).subscribe(data => {
      this.selectedChainsGrid = data;
    });
    this.reportService.getUnassignedStores(this.hotid, groupId).subscribe(data => {
      this.childChainList = data;
    });

     const chainlist = this.reportService.chains.filter((x) => x.storeGroups.some((result) => result.toUpperCase() === groupId.toUpperCase()));
    for (let i = chainlist.length - 1; i >= 0; i--) {
      const item = chainlist[i];
      if (!this.checkDuplicate(item, this.selectedChainsGrid)) {
        this.selectedChainsGrid.push(item);
        const obj = this.childChainList.findIndex(store  =>  store.storeID === item.storeID);
        if (obj != null && obj >= 0) {
          this.childChainList.splice(obj, 1);
        }
       }
    }
    this.loadingService.hide();
  }

  async getAllChainsFromGroup() {
    for (const groupId of this.selectedGroups) {
     await this.moveStoresinGroup(groupId).then(r => r);
    }
    this.updateView();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(val: any): void {
    if (val) {
      this.value = val;
    }
  }

  public sortArray() {
    const temp = [...this.childChainList];
   this.childChainList = temp.sort((a, b) => +a.numberStore - +b.numberStore);
  }

  public selectedCallback = (args) => args.dataItem;

  keyChangeAdd(event){
    this.selectedChains=event;
  }

  keyChangeAddGroup(event){
  this.selectedGroups=event;
  }
  keyChangeRemove(event){
    this.selectedChainsSelectedItems=event;
  }
}
